export function getWidth(id) {
    const ele = document.getElementById(id);
    if (ele) {
        return ele.getBoundingClientRect().width;
    }
    return 0;
}
/**
 * 更多按钮的宽度
 */
export const MORE_BUTTON_WIDTH = {
    small: 36 + 8,
    medium: 45 + 8,
    large: 65 + 8,
};
